import type { FC } from "react"
import { useMemo } from "react"

import { findBearingBetweenTwoPoints } from "@logic/lib/2d"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import {
  positionState,
  siteLocalState,
} from "~/containers/Proposal/state/site/site-state"

import { ReactComponent as StreetViewIcon } from "@svg/street-view.svg"

import { Icon } from "./Styles"

const Wrapper = styled.div`
  transition: transform 0.2s ease-in-out;
  :hover {
    cursor: pointer;
    transform: scale(1.05);
  }
`
const StyledStreetViewIcon = styled(Icon)`
  svg {
    width: 25px;
    height: 25px;
  }
`

const StreetViewButton: FC = () => {
  const location = useRecoilValue(positionState)
  const site = useRecoilValue(siteLocalState)
  const streetViewUrl = useMemo(() => {
    const { streetViewLatitude, streetViewLongitude, latitude, longitude } = site
    const bearing = findBearingBetweenTwoPoints(
      {
        lat: streetViewLatitude ?? latitude,
        lng: streetViewLongitude ?? longitude,
      },
      { lat: location[0], lng: location[1] },
    )

    return `http://www.google.com/maps?layer=c&cbll=${streetViewLatitude},${streetViewLongitude}&cbp=,${bearing},,,0`
  }, [location, site])

  return (
    <Wrapper title="View in Google Street View">
      <a target="_blank" rel="noopener noreferrer" href={streetViewUrl}>
        <StyledStreetViewIcon>
          <StreetViewIcon />
        </StyledStreetViewIcon>
      </a>
    </Wrapper>
  )
}

export default StreetViewButton
